/**
 * @generated SignedSource<<aae53667c3767b9cadb4501eec696fb8>>
 * @relayHash 35a31007da7a8584dd5dff16743fe11f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6f7eeee326e17c5b9e476252d3e39fbd99b274b81f611099789d5280d6b02f2f

import type { ConcreteRequest } from 'relay-runtime';
export type ForgeObservabilityFrontendLogSource = "CONSOLE" | "UNCAUGHT_EXCEPTION" | "UNHANDLED_REJECTION" | "%future added value";
export type ForgeObservabilityPublishFrontendLogsInput = {
  context: ForgeObservabilityFrontendLogContextInput;
  logs: ReadonlyArray<ForgeObservabilityFrontendLogEntryInput>;
};
export type ForgeObservabilityFrontendLogContextInput = {
  appId: string;
  contextAri: string;
  extensionId: string;
  installationId: string;
  userAgent: string;
};
export type ForgeObservabilityFrontendLogEntryInput = {
  args?: string | null;
  errorType?: string | null;
  logId: string;
  logSource: ForgeObservabilityFrontendLogSource;
  lvl: number;
  msg: string;
  timestamp: number;
};
export type emitFrontendLogsMutation$variables = {
  input: ForgeObservabilityPublishFrontendLogsInput;
};
export type emitFrontendLogsMutation$data = {
  readonly ecosystem: {
    readonly forgeObservability: {
      readonly publishFrontendLogs: {
        readonly success: boolean;
      } | null;
    } | null;
  } | null;
};
export type emitFrontendLogsMutation = {
  response: emitFrontendLogsMutation$data;
  variables: emitFrontendLogsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "concreteType": "EcosystemMutation",
    "kind": "LinkedField",
    "name": "ecosystem",
    "plural": false,
    "selections": [
      {
        "concreteType": "ForgeObservabilityMutation",
        "kind": "LinkedField",
        "name": "forgeObservability",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "ForgeObservabilityPublishFrontendLogsResponse",
            "kind": "LinkedField",
            "name": "publishFrontendLogs",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "success"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "emitFrontendLogsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "emitFrontendLogsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "6f7eeee326e17c5b9e476252d3e39fbd99b274b81f611099789d5280d6b02f2f",
    "metadata": {},
    "name": "emitFrontendLogsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "3f0953e113f91299f136bc829278a3b0";

export default node;
